var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "client-grid-file relative w-full h-48 bg-slate-100 border rounded transition-all duration-300",
      class: {
        "border-light-purple": _vm.checked,
        "border-slate-400": !_vm.checked
      },
      style: _vm.checked
        ? { boxShadow: "0px 0px 0px 2px rgba(128, 109, 179, 0.3)" }
        : {}
    },
    [
      _c(
        "div",
        {
          staticClass: "h-full w-full",
          class: {
            "cursor-pointer": _vm.isPreviewAvailable,
            "pointer-events-none": !_vm.isPreviewAvailable
          },
          on: {
            click: function($event) {
              _vm.previewOpened = true
            }
          }
        },
        [
          _vm.contentType
            ? _c(
                "div",
                {
                  staticClass:
                    "h-38 w-full bg-pure-white flex-shrink-0 flex items-center justify-center overflow-hidden rounded-t"
                },
                [
                  _vm.isPreviewAvailable && _vm.contentType.includes("image")
                    ? _c("img", {
                        staticClass: "w-full h-auto",
                        attrs: {
                          src: _vm.document.file_url,
                          alt: _vm.document.filename
                        }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "h-32 w-32 flex items-center justify-center bg-slate-200 rounded-full"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "h-25 w-25",
                            attrs: { icon: "file", color: "slate-6" }
                          })
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "h-10 w-full px-2 flex items-center rounded-b truncate",
              attrs: { title: _vm.document.filename }
            },
            [
              _c("BlTextBody2", {
                staticClass: "truncate",
                attrs: { text: _vm.document.filename }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "action-area absolute top-0 left-0 w-full py-1.5 px-1.5 flex items-center justify-between transition-all duration-300",
          class: { "opacity-100": _vm.checked }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "h-8 w-8 flex items-center justify-center rounded-lg cursor-pointer",
              style: { background: "rgba(239, 239, 239, 0.8)" },
              on: {
                click: function($event) {
                  return _vm.$emit("change-selected")
                }
              }
            },
            [
              _c("BlInputCheck", {
                attrs: { checked: _vm.checked },
                on: {
                  changed: function($event) {
                    return _vm.$emit("change-selected")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "py-1 px-1 flex items-center justify-between gap-1 rounded-lg",
              style: { background: "rgba(239, 239, 239, 0.8)" }
            },
            [
              _c("BlInputButton", {
                attrs: { icon: "delete", type: "outlined-error", dense: "" },
                on: {
                  clicked: function($event) {
                    _vm.deleteOpened = true
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  icon: "download",
                  type: "outlined",
                  dense: "",
                  loading: _vm.downloadLoading
                },
                on: { clicked: _vm.onDownload }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete file",
              label: "Delete file",
              description:
                "<div class='break-words'>You are about to delete <b>" +
                _vm.document.filename +
                "</b> from your client. Are you sure you want to proceed? This action cannot be undone.</div>",
              type: "error",
              submitLoading: _vm.deleteLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onDelete
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.previewOpened
        ? _c("PreviewModal", {
            attrs: { document: _vm.document, checked: _vm.checked },
            on: {
              "change-selected": function($event) {
                return _vm.$emit("change-selected")
              },
              "after-commit": function($event) {
                return _vm.$emit("after-commit")
              },
              "close-modal": function($event) {
                _vm.previewOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01e94225", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e94225","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/file/ItemGrid.vue
// module id = null
// module chunks = 